<script lang="ts">
  import { onMount } from "svelte";
  import Tab from "../../components/Tab/Tab.svelte";
  import Tabs from "../../components/Tab/Tabs.svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { initDetail } from "./contact.store";
import ContactDetailPartActivities from "./ContactDetailPartActivities.svelte";
  import ContactDetailPartChannels from "./ContactDetailPartChannels.svelte";
  import ContactDetailPartCompanies from "./ContactDetailPartCompanies.svelte";
  import ContactDetailPartGeneral from "./ContactDetailPartGeneral.svelte";

  enum ContactPage {
    General = 1,
    Channels,
    Companies,
    Activities
  }

  export let oid: number;

  let currentTab: ContactPage = ContactPage.General;

  onMount(() => initDetail(oid));
</script>

<MainLayout>
  <Tabs>
    <Tab
      label="Generale"
      active={currentTab == ContactPage.General}
      on:click={(_) => {
        currentTab = ContactPage.General;
      }}
    />
    {#if oid != 0}
      <Tab
        label="Recapiti"
        active={currentTab == ContactPage.Channels}
        on:click={(_) => {
          currentTab = ContactPage.Channels;
        }}
      />
      <Tab
        label="Clienti"
        active={currentTab == ContactPage.Companies}
        on:click={(_) => {
          currentTab = ContactPage.Companies;
        }}
      />
      <Tab
        label="Task"
        active={currentTab == ContactPage.Activities}
        on:click={(_) => {
          currentTab = ContactPage.Activities;
        }}
      />
    {/if}
  </Tabs>

  {#if currentTab == ContactPage.General}
    <ContactDetailPartGeneral {oid} />
  {/if}

  {#if currentTab == ContactPage.Channels}
    <ContactDetailPartChannels />
  {/if}

  {#if currentTab == ContactPage.Companies}
    <ContactDetailPartCompanies />
  {/if}

  {#if currentTab == ContactPage.Activities}
    <ContactDetailPartActivities {oid} />
  {/if}
</MainLayout>
